// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardPurseAccountValidityRangeDto
 */
export interface ICardPurseAccountValidityRangeDto {
    /**
     * 
     * @type {Date}
     * @memberof ICardPurseAccountValidityRangeDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardPurseAccountValidityRangeDto
     */
    valid_to?: Date;
}

/**
 * Check if a given object implements the ICardPurseAccountValidityRangeDto interface.
 */
export function instanceOfICardPurseAccountValidityRangeDto(value: object): value is ICardPurseAccountValidityRangeDto {
    return true;
}

export function ICardPurseAccountValidityRangeDtoFromJSON(json: any): ICardPurseAccountValidityRangeDto {
    return ICardPurseAccountValidityRangeDtoFromJSONTyped(json, false);
}

export function ICardPurseAccountValidityRangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardPurseAccountValidityRangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function ICardPurseAccountValidityRangeDtoToJSON(json: any): ICardPurseAccountValidityRangeDto {
    return ICardPurseAccountValidityRangeDtoToJSONTyped(json, false);
}

export function ICardPurseAccountValidityRangeDtoToJSONTyped(value?: ICardPurseAccountValidityRangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
    };
}

